import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { ErrorBoundary } from '@jcu/cookbook-react'
import config from './config'
import App from './app/App'
import * as serviceWorker from './serviceWorker'

ReactDOM.render(
  <ErrorBoundary appName={config.app.name} appContact={config.app.contact}>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Helmet
        titleTemplate={`%s - ${config.app.documentTitle}`}
        defaultTitle={`JCU ${config.sitename}`}
      />
      <App />
    </BrowserRouter>
  </ErrorBoundary>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
